/**
 * This component is used to hide portions of Select component.
 */
export const EmptyComponent: () => null = () => null;
